export default __webpack_public_path__ + "3af4e638df4ae8db7b159f9ebb547877.svg";